import { useEffect } from 'react'

const useOutsideCloseClicked = (setFunc, setFunc2, toogleRef, wrapperRef) => {
  useEffect(() => {
    function handleClickOutside (event) {
      if (toogleRef.current && toogleRef.current.contains(event.target)) {
        return null
      } else if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setFunc('')
        setFunc2('')
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [toogleRef, wrapperRef])
}

export default useOutsideCloseClicked
